import { ApiRoutes } from '../helpers/routes'
import { AppConfig } from '../models/shared'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}`

class UtilitiesService {
    validateCredential = async (token: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.utilities.validateCredential.replace(':token', token)}`,
            {
                method: 'GET',
            },
        )
    }

    getAppConfig = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.utilities.getAppConfig}`, {
            method: 'GET',
        })
    }

    createNewConfig = async (body: AppConfig) => {
        return fetchApi(`${baseUrl}${ApiRoutes.utilities.createNewConfig}`, {
            method: 'POST',
            body: JSON.stringify(body),
        })
    }

    getAbilities = async (text: string, startsWith: boolean) => {
        const params = new URLSearchParams({ text, startsWith: startsWith.toString() })
        return fetchApi(`${baseUrl}${ApiRoutes.utilities.getAbilities}?${params}`, {
            method: 'GET',
        })
    }

    getJobTitles = async (text: string, startsWith: boolean) => {
        const params = new URLSearchParams({ text, startsWith: startsWith.toString() })
        return fetchApi(`${baseUrl}${ApiRoutes.utilities.getJobTitles}?${params}`, {
            method: 'GET',
        })
    }

    getCompanies = async (text: string, startsWith: boolean) => {
        const params = new URLSearchParams({ text, startsWith: startsWith.toString() })
        return fetchApi(`${baseUrl}${ApiRoutes.utilities.getCompanies}?${params}`, {
            method: 'GET',
        })
    }
}

export default UtilitiesService
